import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_onDuplicateTransitionTerm = new ThunderDispatcher('__onDuplicateTransitionTerm');
export const dispatch_showResolutionFunctionEditorPanel = new ThunderDispatcher('__showResolutionFunctionEditorPanel');
//# sourceMappingURL=dispatchers.js.map